// File: src/pages/Addplan.jsx  (or keep your existing path)
import React, { useEffect, useState, useMemo } from "react";
import {
  Button,
  Card,
  CardBody,
  Col,
  Input,
  Form,
  Label,
  Row,
} from "reactstrap";
import {
  SubscriptinPlan,
  SubscriptinPlan_by_id,
  Update_SubscriptinPlan_by_id1,
} from "../../import/ApiEndPoint/Api";
import { _Get, _PostSave, _Put } from "../../import/ApiEndPoint/ApiCalling";
import swal from "sweetalert";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import Multiselect from "multiselect-react-dropdown";

const injectOnce = () => {
  if (document.getElementById("plan-two-card-css")) return;
  const s = document.createElement("style");
  s.id = "plan-two-card-css";
  s.textContent = `
    .toolbar-card{ border:1px solid #e5e7eb; border-radius:14px; background:#f4f7f6; }
    .toolbar-title{ font-weight:800; text-transform:uppercase; font-size:18px; }
    .form-card{ border:1px solid #e5e7eb; border-radius:14px; background:#fff; }
    .form-card .form-group{ margin-bottom:10px; }

    /* Multiselect polish to match your screenshot */
    .groups-ms .chip{ background:#eaf0ff; color:#0f172a; font-weight:700; border-radius:16px; }
    .groups-ms .searchBox{ padding:6px 10px; border-radius:8px; }
    .groups-ms .optionContainer{ border-radius:8px; }
  `;
  document.head.appendChild(s);
};

function Addplan() {
  const [Data, setData] = useState({
    subscriptionType: 0,
    planName: "",
    subscriptionCost: "",
    annualMaintenanceCost: "",
    days: "",
    noOfUser: "",
    groups: [], // string[] of group ids
  });
  const [View, setView] = useState("Add");
  const [Loader, setLoader] = useState(false);

  // groups list for dropdown (Multiselect expects objects)
  // We'll map each group to { _id, roleName } so displayValue="roleName" works
  const [groupOptions, setGroupOptions] = useState([]); // [{_id, roleName}]
  const [selectedGroupObjs, setSelectedGroupObjs] = useState([]); // Multiselect selectedValues

  const navigate = useNavigate();
  const Params = useParams();

  useEffect(() => injectOnce(), []);

  // --- Fetch all groups
  const loadGroups = async () => {
    try {
      const res = await axios.get(
        "https://rupioodms-backend.rupioo.in/groups/list",
      );
      const list = Array.isArray(res?.data?.Groups) ? res.data.Groups : [];
      const options = list.map((g) => ({
        _id: String(g?._id),
        roleName: g?.groupName || g?.name || "Unnamed Group",
      }));
      setGroupOptions(options);
      return options;
    } catch (e) {
      console.error("[groups/list] error:", e);
      setGroupOptions([]);
      return [];
    }
  };

  // --- Fetch a single plan for edit mode
  const loadPlan = async (id, optionsForSelect = []) => {
    try {
      const res = await _Get(SubscriptinPlan_by_id, id);
      const sub = res?.Subscription || {};

      const normalizedGroups = Array.isArray(sub?.groups)
        ? sub.groups
            .map((g) => (typeof g === "string" ? g : g?._id))
            .filter(Boolean)
            .map(String)
        : [];

      setData({
        subscriptionType:
          typeof sub?.subscriptionType === "number"
            ? sub.subscriptionType
            : Number(sub?.subscriptionType) || 0,
        planName: sub?.planName ?? "",
        subscriptionCost:
          sub?.subscriptionCost === undefined
            ? ""
            : Number(sub.subscriptionCost),
        annualMaintenanceCost:
          sub?.annualMaintenanceCost === undefined
            ? ""
            : Number(sub.annualMaintenanceCost),
        days: sub?.days === undefined ? "" : Number(sub.days),
        noOfUser: sub?.noOfUser === undefined ? "" : Number(sub.noOfUser),
        groups: normalizedGroups,
      });

      // Preselect in Multiselect based on IDs
      const opts = optionsForSelect.length ? optionsForSelect : groupOptions;
      const preselected = opts.filter((o) => normalizedGroups.includes(o._id));
      setSelectedGroupObjs(preselected);

      setView("Update");
    } catch (err) {
      console.error("[plan by id] error:", err);
      setView("Update");
    }
  };

  useEffect(() => {
    (async () => {
      const options = await loadGroups();
      if (String(Params?.id) === "0") {
        setView("Add");
      } else {
        await loadPlan(Params?.id, options);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === "planName") {
      setData((p) => ({ ...p, planName: value }));
    } else if (name === "subscriptionType") {
      setData((p) => ({ ...p, subscriptionType: Number(value) }));
    } else {
      setData((p) => ({ ...p, [name]: value === "" ? "" : Number(value) }));
    }
  };

  // Multiselect handlers
  const onSelectRoles = (list) => {
    setSelectedGroupObjs(list);
    setData((p) => ({ ...p, groups: list.map((x) => x._id) }));
  };
  const onRemoveRoles = (list) => {
    setSelectedGroupObjs(list);
    setData((p) => ({ ...p, groups: list.map((x) => x._id) }));
  };

  const handleCreateSubscription = async (e) => {
    e.preventDefault();
    setLoader(true);

    const payload = {
      subscriptionType: Number(Data.subscriptionType) || 0,
      planName: Data.planName,
      subscriptionCost: Number(Data.subscriptionCost) || 0,
      annualMaintenanceCost: Number(Data.annualMaintenanceCost) || 0,
      days: Number(Data.days) || 0,
      noOfUser: Number(Data.noOfUser) || 0,
      groups: Array.isArray(Data.groups) ? Data.groups.map(String) : [],
    };

    try {
      if (View === "Add") {
        await _PostSave(SubscriptinPlan, payload);
        swal("Success", "Plan Created Successfully", "success");
      } else {
        await _Put(Update_SubscriptinPlan_by_id1, Params?.id, payload);
        swal("Success", "Plan Updated Successfully", "success");
      }
      navigate(-1);
    } catch (err) {
      console.error(err);
      swal("Error", "Something went wrong", "error");
    } finally {
      setLoader(false);
    }
  };

  const showPrice = Number(Data.subscriptionType) !== 0;
  const showAMC = Number(Data.subscriptionType) === 1;
  const canSubmit = useMemo(
    () => Data.planName.trim() && Number(Data.subscriptionType) > 0,
    [Data.planName, Data.subscriptionType],
  );

  return (
    <>
      {/* ===== Card 1: Title + Action button ===== */}
      <Row style={{ marginBottom: 10 }}>
        <Col sm="12">
          <Card className="toolbar-card" style={{ padding: 8 }}>
            <div
              style={{
                display: "flex",
                gap: 12,
                alignItems: "center",
                flexWrap: "wrap",
              }}
            >
              <div className="toolbar-title">{View} Plan</div>
              <div style={{ flex: "1 1 240px" }} />
              <Button
                color="secondary"
                style={{ height: 32 }}
                onClick={() => navigate(-1)}
                disabled={Loader}
              >
                Back
              </Button>
            </div>
          </Card>
        </Col>
      </Row>

      {/* ===== Card 2: Form ===== */}
      <Row>
        <Col sm="12">
          <Card className="form-card">
            <CardBody>
              <Form onSubmit={handleCreateSubscription} className="p-1">
                <Row>
                  <Col className="mb-1 mt-1" lg="4" md="4">
                    <Label>Subscription type *</Label>
                    <Input
                      required
                      type="select"
                      name="subscriptionType"
                      value={Data.subscriptionType}
                      onChange={handleInputChange}
                    >
                      <option value={0}>----select----</option>
                      <option value={1}>One Time</option>
                      <option value={2}>Yearly</option>
                    </Input>
                  </Col>

                  <Col className="mb-1 mt-1" lg="4" md="4">
                    <Label>Plan Name *</Label>
                    <Input
                      required
                      type="text"
                      name="planName"
                      placeholder="Enter Plan Name"
                      value={Data.planName}
                      onChange={handleInputChange}
                    />
                  </Col>

                  {showPrice && (
                    <Col className="mb-1 mt-1" lg="4" md="4">
                      <Label>Plan Price *</Label>
                      <Input
                        required
                        type="number"
                        name="subscriptionCost"
                        placeholder="Enter subscription cost"
                        value={Data.subscriptionCost}
                        onChange={handleInputChange}
                      />
                    </Col>
                  )}

                  {showAMC && (
                    <Col className="mb-1 mt-1" lg="4" md="4">
                      <Label>Annual Maintenance Cost *</Label>
                      <Input
                        required
                        type="number"
                        name="annualMaintenanceCost"
                        placeholder="Enter annual maintenance cost"
                        value={Data.annualMaintenanceCost}
                        onChange={handleInputChange}
                      />
                    </Col>
                  )}

                  <Col className="mb-1 mt-1" lg="4" md="4">
                    <Label>Days of Plan *</Label>
                    <Input
                      required
                      type="number"
                      name="days"
                      placeholder="Enter number of days"
                      value={Data.days}
                      onChange={handleInputChange}
                    />
                  </Col>

                  <Col className="mb-1 mt-1" lg="4" md="4">
                    <Label>No of Allowed User *</Label>
                    <Input
                      required
                      type="number"
                      name="noOfUser"
                      placeholder="Enter allowed users"
                      value={Data.noOfUser}
                      onChange={handleInputChange}
                    />
                  </Col>

                  {/* ===== Groups Multiselect (your exact API) ===== */}
                  <Col className="mb-1 mt-1 groups-ms" lg="6" md="6">
                    <Label>Groups</Label>
                    <Multiselect
                      className="w-100"
                      showCheckbox
                      isObject
                      options={groupOptions}
                      selectedValues={selectedGroupObjs}
                      displayValue="roleName"
                      onSelect={onSelectRoles}
                      onRemove={onRemoveRoles}
                      placeholder="Select"
                    />
                    <small style={{ color: "#6b7280" }}>
                      Pick one or more groups.
                    </small>
                  </Col>
                </Row>

                <div className="d-flex justify-content-center mt-2">
                  <Button
                    type="submit"
                    color="primary"
                    disabled={Loader || !canSubmit}
                    style={{ minWidth: 120 }}
                  >
                    {Loader ? "Please wait..." : View}
                  </Button>
                </div>
              </Form>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </>
  );
}

export default Addplan;
